import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { ArrowRight, Brain, Droplets, Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 px-4 bg-secondary text-secondary-foreground" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <div className="text-center mb-16" data-id="element-104">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-105">
            The 3-Day Accelerated Immersion Protocol
          </h2>
          <p className="text-xl text-white/80 max-w-2xl mx-auto" data-id="element-106">
            This method compresses months of "trying" into one long weekend.
            Instead of relying on bribes or willpower, we use immediate
            biological feedback.
          </p>
        </div>

        <div className="relative" data-id="element-107">
          {/* Desktop connecting line */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-white/20 -translate-y-1/2 z-0" data-id="element-108"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-109">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-white text-foreground rounded-2xl p-8 shadow-xl text-center flex flex-col items-center" data-id="element-110">
              <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mb-6" data-id="element-111">
                <Droplets className="w-8 h-8 text-secondary" data-id="element-112" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-113">No diaper barrier</h3>
              <p className="text-foreground/70" data-id="element-114">
                The physical block is removed completely.
              </p>
            </motion.div>

            <div className="hidden md:flex items-center justify-center absolute left-1/3 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20" data-id="element-115">
              <div className="bg-secondary text-white rounded-full p-2" data-id="element-116">
                <ArrowRight className="w-6 h-6" data-id="element-117" />
              </div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white text-foreground rounded-2xl p-8 shadow-xl text-center flex flex-col items-center border-4 border-primary transform md:scale-105" data-id="element-118">
              <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6" data-id="element-119">
                <Zap className="w-8 h-8 text-primary" data-id="element-120" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-121">Child feels the signal</h3>
              <p className="text-foreground/70" data-id="element-122">
                Immediate, clear biological feedback.
              </p>
            </motion.div>

            <div className="hidden md:flex items-center justify-center absolute left-2/3 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20" data-id="element-123">
              <div className="bg-secondary text-white rounded-full p-2" data-id="element-124">
                <ArrowRight className="w-6 h-6" data-id="element-125" />
              </div>
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white text-foreground rounded-2xl p-8 shadow-xl text-center flex flex-col items-center" data-id="element-126">
              <div className="w-16 h-16 bg-accent rounded-full flex items-center justify-center mb-6" data-id="element-127">
                <Brain className="w-8 h-8 text-secondary" data-id="element-128" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-129">Brain learns faster</h3>
              <p className="text-foreground/70" data-id="element-130">
                The connection is made in hours, not months.
              </p>
            </motion.div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-131">
          <p className="text-2xl font-serif italic text-white/90" data-id="element-132">
            It's not magic. It's a clean, repeatable system.
          </p>
        </motion.div>
      </div>
    </section>;
}